import { Alert } from '@fukuri-admins/ui/common';

type Props = {
  /** 閉じるボタンのクリックハンドラー */
  onClose: NonNullable<React.ComponentProps<typeof Alert>['onClose']>;
};

export const StressAssessmentScheduleNotificationBannerPresentation: React.FC<Props> = ({
  onClose,
}) => (
  <Alert
    status='info'
    description='ストレスチェックの実施月です。さっそく開始しましょう'
    showClose
    onClose={onClose}
  />
);
